<template>
  <div class="knowledge-container">
    <!-- 上传文件蒙版 -->
    <el-dialog title="上传资料"
               :visible.sync="isUploadShow"
               width="530px"
               class="doc-upload-area"
               :close-on-click-modal="false"
               :before-close="cancelUpload">
      <div>
        <h4 style="text-indent: 20px">标题：</h4>
        <input type="text"
               v-model="uploadFileTitle"
               placeholder="请输入文档标题（限200字）..." />
        <h4 style="text-indent: 20px; margin-top: 20px">下载所需积分：</h4>
        <input type="text"
               v-model="uploadFileScore"
               placeholder="请输入下载所需积分（0-5）" />
        <h4 style="margin-top: 20px; text-indent: 20px">描述：</h4>
        <textarea v-model="uploadFileDescribe"
                  placeholder="请输入文档描述（限1000字）..."></textarea>
      </div>
      <!-- 一二三级类目选择区域 -->
      <div class="doc-upload-typechoose">
        <div v-if="uploadFileTypeChooseOne"
             class="doc-upload-kindonechoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px">
          <h4 style="padding-left: 20px">分类</h4>
          <ul>
            <li @click="handleUploadFileTypeOneChoose(index, item)"
                :class="
                activeUploadFileTypeOneIndex === index
                  ? 'uploadFileTypeOneActive'
                  : ''
              "
                v-for="(item, index) in uploadFileTypeChooseOne"
                :key="index">
              {{ item.fileTypeName }}
            </li>
          </ul>
        </div>
        <div v-if="uploadFileTypeChooseTwo"
             class="doc-upload-kindtwochoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px">
          <ul>
            <li @click="handleUploadFileTypeTwoChoose(index, item)"
                :class="
                activeUploadFileTypeTwoIndex === index
                  ? 'uploadFileTypeTwoActive'
                  : ''
              "
                v-for="(item, index) in uploadFileTypeChooseTwo"
                :key="index">
              {{ item.fileTypeName }}
            </li>
          </ul>
        </div>
        <div v-if="uploadFileTypeChooseThree"
             class="doc-upload-kindtwochoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px">
          <ul>
            <li @click="handleUploadFileTypeThreeChoose(index, item)"
                :class="
                activeUploadFileTypeThreeIndex === index
                  ? 'uploadFileTypeThreeActive'
                  : ''
              "
                v-for="(item, index) in uploadFileTypeChooseThree"
                :key="index">
              {{ item.fileTypeName }}
            </li>
          </ul>
        </div>
      </div>
      <!-- 上传文件部分 借助element upload组件 -->
      <div style="padding-left: 20px"
           slot="tip"
           class="el-upload__tip">
        只能上传doc/docx/pdf/ppt/pptx/xls/xlsx文件，且不超过100Mb
      </div>
      <el-upload
        class="upload-demo"
        :before-remove="removeFile"
        :on-success="successFile"
        :on-error="errorFile"
        :before-upload="beforeUpload"
        :file-list="fileList"
        ref="upLoadFile"
        :limit="1"
        :on-exceed="handleExceed"
        :headers="headerMsg"
        accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.pdf"
        :action="uploadURL"
      >
        <div slot="trigger" class="uploadPickUp">
          <i class="el-icon-upload2"></i> 选取文件
        </div>
        <p>文件大小不能大于100MB</p>
        <p>支持拓展名：.pdf .doc .docx .xls .xlsx .ppt .pptx</p>
        <!-- <p>文件名只支持汉字、英文字母以及数字</p> -->
        <el-button style="
            width: 265.5px;
            margin-top: 50px;
            margin-left: 235px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1d65a8;
            color: white;
            border: 0;
            display: none;
          "
                   size="small"
                   type="success"
                   @click="submitUpload">确定</el-button>
      </el-upload>
      <div style="
          display: flex;
          margin-top: 40px;
          width: 530px;
          margin-left: -20px;
          margin-bottom: -30px;
        ">
        <div style="flex: 1"
             class="upload-cancel"
             @click="cancelUpload">
          取消上传
        </div>
        <div style="
            width: 265.5px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1d65a8;
            color: white;
            text-align: center;
            line-height: 52px;
            flex: 1;
            user-select: none;
            cursor: pointer;
            font-size: 16px;
            font-weight: normal;
          "
             @click="submitUpload">
          确定上传
        </div>
      </div>
    </el-dialog>
    <!-- 知识社区轮播图 -->
    <div class="k-banner"
         v-if="fiveSDataList.length">
      <el-carousel height="400px"
                   arrow="never">
        <el-carousel-item v-for="(item, index) in fiveSDataList"
                          :key="index"
                          height="400px"
                          arrow="never">
          <img :src="item.url"
               alt="知识社区轮播图"
               @click.stop="getSwiperDetail(item.id)" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 搜索、提问、上传功能条区域 -->
    <div class="k-function">
      <input type="text"
             @keypress.enter="jumpSearchPage"
             placeholder="请输入要查询的内容"
             class="k-search"
             v-model.trim="searchtext" />
      <div class="k-f-s"
           @click.stop="jumpSearchPage">
        <i style="font-size: 20px; padding-top: 13px; padding-left: 13px"
           class="el-icon-search"></i>
      </div>
      <button class="k-f-ask"
              @click="jumpExpertAsk">我要提问</button>
      <button class="k-f-upload"
              @click="showUpload">上传资料</button>
    </div>
    <!-- 技术文档区域 -->
    <div class="k-tecdocument">
      <h2>工控文库</h2>
      <!-- 技术文档一级分类选择区域 -->
      <div class="k-doctypelisthead"
           v-if="tecDocTypeList">
        <ul class="k-doctypelist">
          <li v-for="(item, index) in tecDocTypeList"
              :key="item.id"
              :class="index === currentDocType ? 'k-doctypelist-active' : ''"
              @click="changeDocTypeIndex(index, item)">
            {{ item.fileTypeName }}
          </li>
        </ul>
        <!-- 技术文档列表跳转 -->
        <router-link class="k-doctypelist-more"
                     to="/trainbookDocList">
          <span>更多</span>
          <!-- <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC"> -->
          <div class="morePicture"></div>
        </router-link>
      </div>
      <!-- 技术文档缩略展示区域 -->
      <div v-if="
          tecDocList &&
          tecDocList.allothers.length === 0 &&
          tecDocList.hot.length === 0 &&
          tecDocList.newVoList.length === 0 &&
          tecDocList.perfect.length === 0
        "
           style="
          width: 1190px;
          height: 630px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #ffffff;
        "
      >
        <img style="display: block" :src="BASE_URL + 'img/kong.png'" alt="暂无数据" />
        <h3 style="margin: 30px; font-size: 28px">
          该分类下暂无文档，请浏览其他分类
        </h3>
      </div>
      <ul class="k-doclist"
          v-if="tecDocList">
        <li v-for="(item, index) in tecDocList.perfect"
            :key="index"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <img alt="精品"
               class="k-doctype k-supremedoc"
               src="data:image/png;base64,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" />
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL"/>
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <div>{{ item.fileViewCount }}人浏览</div>
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState1(index, item.collectionDataId, item)
                " />
              <div class="k-docview-collect"
                   @click.stop="
                  changeLikeState1(index, item.collectionDataId, item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDE4NEY3ODY5RDQ4MTFFOUIxNkRBMjIzM0E4RUQxM0UiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDE4NEY3ODc5RDQ4MTFFOUIxNkRBMjIzM0E4RUQxM0UiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0MTg0Rjc4NDlENDgxMUU5QjE2REEyMjMzQThFRDEzRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0MTg0Rjc4NTlENDgxMUU5QjE2REEyMjMzQThFRDEzRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PstOx9kAAAJtSURBVHja7NfNTxNBGAbwZ9qlllZam9JKxI/aKHgixgOFGjx6VsLBSCIejIl34C/w4gdc0KoHP4jeTEyIB0qDBmNiggoUaSkIVQOt2oRqgyjQ7u44sy2lh8Z2G2ti0jfZPczu7K8zs/NsCkop1B6j7z7Ty4/99NemSEvpr4HK2khKuDs6j/vPFvAyFEMppRolGsLPSEoSLEbdv0H/RlXQClpBK2h+NLiUoLdH5uhmSqJbjavrKXrlyQyNJdZVP1CSKe49f099U1Ga2/5qPkYfvghTkTFC39MAxgJfUWvSo6PVodzg80dx0zsL33SE3rl0HIfqTKQYkP1w1i9EPd45NO4xo7nBhl0sn9c2RPQPBRGKJuDcXUM1MvvUiCy8zTnh7WI3uxvtWPiyiu7B1wjHftCCoChnQUOVFp1tTpgN28+UM18oy05d/jXdZzWSq13NaGmwYzIcR/eDP8Mc9AzP0lsjDNRp0dvehDNtTkKIyhdpf62RXD+fhifCKwwezwtvgR4GVrMR9p5uwlkGaggp7e3l8DU2YpcCx9EzOI7llbUszJcmCwpa9JwqDBa1ZQ7YGHwuDb9d5PAbpERJueadioKvoZ6DbISdJwqDRe9Thz0DH7YpU+3/GFfaH40tQp+Z0mJBVeGgwF0uBebryEuvUw+qTiQOD1xoxbGDVlhrdqia0twS1CZOnaWa3LjoZhs+hSP15pJiUCil016r4f8IfFGSt0eq06bd/qEZDE9EaDnAJAMj8Z8wsVisYp7Q4XZg8kMcweWEcpSrBC1Be4uDBw4I/28RWPpOpz99Q1KUy4bazXqcPFrPR0p+CzAAv39VPVXoUmkAAAAASUVORK5CYII=" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
        <li v-for="(item, index) in tecDocList.hot"
            :key="index + 3"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <img alt="热"
               class="k-doctype k-hotdoc"
               src="data:image/png;base64,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" />
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL"
                 :alt="item.userNickname" />
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <div>{{ item.fileViewCount }}人浏览</div>
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState2(index, item.collectionDataId, item)
                " />
              <div class="k-docview-collect"
                   @click.stop="
                  changeLikeState2(index, item.collectionDataId, item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,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" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
        <li v-for="(item, index) in tecDocList.newVoList"
            :key="index + 6"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <img class="k-doctype k-newdoc"
               src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjgyNjJEMjM5RDQ3MTFFOUJCMUVFNzA2MDAyOUFEMTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjgyNjJEMjQ5RDQ3MTFFOUJCMUVFNzA2MDAyOUFEMTUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2ODI2MkQyMTlENDcxMUU5QkIxRUU3MDYwMDI5QUQxNSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2ODI2MkQyMjlENDcxMUU5QkIxRUU3MDYwMDI5QUQxNSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pi2aLygAAA6/SURBVHja7J0JVNV1Fscvq2yyrwYISLhVuCCaYi5jo5h2bCwzlxxNMrdRM007jUvWlHPspKOVinvWUZvM0rFGTXADRNyVxUAFQWWVfQfnfi8+hsemwQPee3A977y/7/9//4efd5fvvb+fquMSsOchtZlKrJ+XPem2YVAdzH3vDdFpA6pCmDjWb+kfxs7ciMb7eVB7Y306HZVCp6Lu08OHmglTLYDOGN6Fpgz2lOOC4jI6GXlfY2HCWjTk2xsb0PAeT1E7Az26/6CAth//XaNhtjjQuSO7kaOlMWXnF9OmI9GUmVes0TBbFGjnpyxojK+reOeNe9m098ytWq8b2NVBY2C2GFBDfV1aPcmHHK1MONTz6YPdEVRSVl7juoBhXrRlth/tWzhE3qPuMFsM6Iw/dyYv9tDcghLa9tsNik7KqhXmbP9uZGyoT+4O7UlHR0ftYbYI0GddrWjiC53IzMiA4lNzaWdwbJ0wrdu3o+TMfJq3NYyKSsrUHmaLALU0NaS8olLWmg/JzcGM1k/vR0aGerXCLC9/SGk5RXQ+Lk0jYDYrUNN2+rR9zkDJid+eiKPY+9lkwuE8sJsjbWCoBnq6SjAzcotIV1eHPDjcN84cwKGvp/YwmxRoLw8b6mBtIsdmRvq0maH4oWJzF9TF2ZKmbTgtUI24ygPqR2/0Ugrz93edo1vJOZJD+3e2p69m9G9WqA2BCdNpimnT6wPcaeX4XpTJ+jIhJZc/hainu420lAjvF1f+SjFciDramdGOuQPFCxVFJyWrgN7/JoJ+u3KXvDpYUCB/EShKBcWlFBKTQrM2hUhHpY4wm8RDAWzqUC8qZRnUgWVRP/Yu/IDlTFORK1cxbBiK0oZfIikxPV9yKnJmAr8WdPWenL9xN4sCvj7TrJ7aGJgwPYver65Q5Q9UWvaQ9oXcooS0PBrZy0VeyyssYY+7R7Es4D0dzcmQgUTEptG8Ud1p5oiulJZdSNksoazN2pEVP9zszejY5bvIDpTORQmeCYFvZ2FMTlbG9JybNR25lCSfpU4wmwQozIQL0NK/eJODpZHIHYTvuzvC6VrCA/Lv5UwODAad0vPscfC8B1yAFnPO9OlkK2Lf1daM32tMQdcqPLU5oKoCZpMARVjv4GoOOMiZ1xIyaVZgKBUy2Afcq/f0sBWY6OH1dXUF8pv/OklxHNahDG1Qd0eBifyay559Jf5Bk0NVFcwmyaFbZvlJhUcriULj1cGcflg0lF7gSg77/V4WFZeWURnnS8CctuGUaM2/v+ZNv630Fzh3M/Il9Oe91F2+GIXVllM3vjNAIkIdYDYJUIRvMlfqS7cz5FmPvbA7d0dfBjwv0ukt1pqG+noUdz9HPBMwl43rQeP6e0hhQj5d/eMV9shC8dR/vtlHcmtdUNF56enqqAXMJgn5/15MIlc7U1qwLZy+4bYSULu5WJIN60voUuhOeKcVd0w9WEp5u1nR2H7uZG5iILp06vpTdOFmukB8hmFZ8OtQVGeiUyo/QxH+HflzjnLxCr5+Xy1gNgrokGec6DY0ZjVDNjsVmUylDA3gohKzBKi7fXuBiUHI/cwC8T4AduIiZGtuxKkgW/p7H09beQ69kUIDulTkS1dbUylQGbnFSlBxHygKdYHZYGH/6vNu9O7Lz0h4T+UcmJJVWHs+Ydf6ZGJvGt3HRdpMRc7MZ2F+9rPRZMFeCktlL16x7xJ9MbWvjOmKuYCl873R95eUlstk/8eweJq//azaVHOV5VDAhCRytjGlrtxCbp09UBbaajOA7OpsoQQTOfM9/jLKHwl5NACWHN5Th3jSmp+uUkh0snifOUOE5MIgBcXN18tOKZeqI8w/HPIKmFihRFFA3w2Y/bvY01GWL/nVWkK0l0lcsQFi7pawR9WcCxC3pubGhlJgbqbkSNg7WJpIz4+C882JOG4McqmQ74drvDnXGrDnnotNrTXNqAvMP+ShVWGGxqTS2xvPsE4sJX09ruIuVrSde3Lb9jU9CPkUaSGVqzeWPACzPedIgPoxPJ4+/vclunw7nSBan3OzoW2z/aQIfR9ymxax2F/3n0i5Fu3opVsZag3ziXNodZiAsIklUCcZWpRROwNdEfHX72TSW1+eEtDfzh8kehSe+fO5BHqKC9CJVSPlCwCgGH786bkOIp8mrQ1mSVWhXxHeVxjwtC9Pq2TRrjlhPpGH1gfzJof95HUnuAsqF1DowTtxr76VvQySB7CRElBUEPr9lhwUSfTeznCBD/mIjgmt5vSvTlP476mSV+Gp0J+NXfVobpiPBfo4mAEM4aXeLlyJy6TiQ3fOHdlVuhsUm2CWOj+E3eaiVDEdQg5F+KOd/O5kHL+nWICP7O1MOQUlNIPTCFIDKj0EO4S7JsGsF+iTwJw0yFOuQ874lgH1cLemPp52AvMEi+0iBh30kT/tqbJqmZVfEcaYLuE+mMr35FCHxArmlFAhlcpEuGMGqkkw6wT6R2BCvGNJozrM4+ydr/R14w7JSIS7f0/nGp+jWO3s39mBwWLMVyrgAXPl3osN2uPUkjBh+o2GWYtnHoxIkIk9DNLHwsSQXunXkX7i4lTVvv41ily4C9oZFCtDkUF/P0zdWNtGJmZqnGfWChT5EDChBxsL055bxqT0PBk0Y+6J5QzcFwpAYcipb7PurGqaDFMp5FGVP57Qi3tnI8lraw9dbzRMSKbvTsVJLsREqHpHpaqlDHWBqQQ0OilThDOGuthvtGveCw2Gmcgw52wJpYi4NLrHcgm5UZ+BIp8qQAa82Jmi148V79UWmEohjxyG8Pv8r770oncHyXsZHJKLdp6rF2bYjVRafziSdv7tBYGZz703hh3onrAWj/vifSbt9Kjv03ayDQfzUYzzIOJH9nKWSb02wKy1U8KGgy+m+koXY8otYjTnNIzZqsOEF8MwXcfaESoyxD2GxACFiT20JYQ6xnamnD+LS8sr34ctjOiE5m0Lo/Nx6VoBs87WE9IFo7ShzzoJVIj2qjAxKbqekMmeZiniG2Ai7zyQfUpYfx/GX4Yxe6QhAzZmL8V8E2M46NLs/BJZPoawP3I5qUFr7OoKs95eXjx1Wl9ZFKsO80xUMn1x8Dr9tHSYeCUM0/bp3H8j56JldLMzk5yJRbfZ/l2los/eHMJ9egaDLdeanPnEnRJCdk5gKC3Yfpa83ZRhrj5wVTZ5ASZ0JvIm1tuxbwm7QBD+CG8UJehKXIeh8bnYNK2G+dheHkON6cO8yPfpipyJ8P7oe9amM/qTBwNMZI35+udBle2k56PByOrJPnTy45ekmnd2tpBzUQ3Ul5oEs9ZOqSpMzCaxkAZvRbGBp+3lvhwDYcCcFRhCL/u4yjJuTkGxnMe0CXoT3rx8XE+yZLUA4PvPxms9zDo9FIMKazNDcrQylup+inVmBFdiHAMmtOo7m84IzNcGuIto//VikjwA3pwhYhnjjYEeAhtpIfjRLhBthlmnh8K74lPzaPORGFlZPHblrmjKTe8MkPBHKC8d6y0jNnRVh8/fkWt3sBaFZJKNYiy1sMa+4ZcomchrWzVvUA7F2g6EO4oMenDMKzEEhljHEi+23QQejaFPfrhMa9/qJwt32I54Nf6BLLDBO93sTOnizYxWAfOJJvYQ5wqrChXAdPgXGoDPJvUhLydz1qNF9BV75Lg1x6UIbT9+gz7/+Zp4fGuAWa8Orc8wNVKEP/InoEMB/HLxDs3b2ri1c02G+UQeWpvBU7GIdpQ7HVR2TNljkjLpg93nWzXMBgOFYQND70c74zBdmrftrGxKaM0w69Wh9RkmUZs55LE5FpV8+Z4L0nK2dpgN9lAI9de48KC9/AdX+GNX7rXBbExRUhg6Iiz7tsFUQQ6FtcFUMdA2mGoAVJthNjtQbYfZrEBbA8xmA9paYDYL0NYEs8mBtjaYTQq0NcJsMqCtFWaTAG3NMFUOtLXDVCnQNpgqBNoGU4VA22Aqm762wywpKSEDA4PK3+fk5NCiRYvk+MMPPyRn5///ZYrs7GwyNzevcY/ly5fLfoNhw4aRn59f03ioJsBcuXIlDRkyhK5fv64EOCIiQh4FBQWVr9++fZtGjBhBn376aY37nDx5kg4dOkQxMTFNE/KaEuY2NjZUWFhIgYGBj71248aNVFxcTC4uLkqvZ2VliVfD3NzcVA9Uk3Lm5MmTyczMjE6fPk1RUVF1XhcaGkrHjh0jDw8PGj9+vNK5xMTEyuOOHTuqFqimFSALCwuaMGGCHNflpbm5ubRq1So5Xrx4MenrK5eVO3fuVIDS1SVXV1fVFSVNreYAeuHCBRo+fHid14wePZrS09PJx8enxrno6Gh5NjQ0pHXr1tX7WVZWVk8GVBNhxsbGSv6DBQQEyPP58+cr8yEsMjJSKruvr2/leZi7uztZW1vL8bVr1+QZuXjv3r31fibyr762eia8CbmxPlOEenVbsWIFjRo1ikpLSys9FPnT0tKyRn6FZ8MzkQ7s7e3rB6rJoh1/ePwBq1pqaqpsCFYYvLB6zoQZGRlVejk8EwY55eXlpXTdkiVLpJhBbi1cuLD+HKrpHVB17zt48GClLg0KCpLXBg8eTHPmzKlVzMNCQkIqIDF0T0/PGufT0ir+5V1HR8f6q7y2tZPIlfAwW1tbmjt3buXr+/fvpzFjxtDu3bslvKubAjzO3bx5s8Z5ePxjgWobTOQ5tJoQ7ZBF0KUKW7BggYT32rVraezYsXT06NHKc8nJyUraNTw8vE4PdXBwqB2otsE8fPgwTZw4UeAg1IcOHap0HtV9z549EvpJSUm0dOlSWrNmjZxDbqxq1YFCLRQVFdXtodoEMz8/n5YtWyaPvLw88vf3r7VHhyF/AiJSgampqXRK5eXltG/fPjnv7e0tz9CyZWVlNbwT+RUtrhJQbfNMdD/BwcFyPH36dClQtVXzqjZlyhQ6cOCATJ/wXngsuiNMmqAv8SUpNCksPj6+Mtyr/qcF+j4e1lo3z4RcmjlzpuRLdEFVzcTEhObPny/HdnZ2NTod2PHjx+UZ4zroS6SLXbt2SZFSeGxYWJg8Ozk5Kd3jfwIMAPON2HWHQwrHAAAAAElFTkSuQmCC" />
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL"
                 :alt="item.userNickname" />
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <div>{{ item.fileViewCount }}人浏览</div>
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState3(index, item.collectionDataId, item)
                " />
              <div class="k-docview-collect"
                   @click.stop="
                  changeLikeState3(index, item.collectionDataId, item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,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" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
        <li v-for="(item, index) in tecDocList.allothers"
            :key="index + 9"
            class="k-doclistv-view"
            @click="jumpDocDetail(item)">
          <h3 class="overell">{{ item.fileTitle }}</h3>
          <p>{{ item.discribe }}</p>
          <div class="k-docauthor">
            <img class="k-docauthor-icon"
                 :src="item.userAvatarURL || defaultImg"
                 :alt="item.userNickname" />
            <div class="k-docauthor-name">{{ item.userNickname }}</div>
            <div class="k-docauthor-date">发布日期：{{ item.createTime }}</div>
          </div>
          <div class="k-docview">
            <div>{{ item.fileViewCount }}人浏览</div>
            <div class="k-docview-use">
              <img class="k-docview-likeicon"
                   alt="收藏"
                   :src="item.collectionDataId ? likeUrl : notLikeUrl"
                   @click.stop="
                  changeLikeState4(index, item.collectionDataId, item)
                " />
              <div class="k-docview-collect"
                   @click.stop="
                  changeLikeState4(index, item.collectionDataId, item)
                ">
                {{ item.collectionDataId ? "已收藏" : "收藏" }}
              </div>
              <img class="k-docview-downloadicon"
                   alt="下载"
                   @click.stop="download(item)"
                   src="data:image/png;base64,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" />
              <div class="k-docview-download"
                   @click.stop="download(item)">
                下载
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 技术视频 -->
    <div class="k-video">
      <h2>技术视频</h2>
      <!-- 技术视频一级分类选择区域 -->
      <div class="k-videoTypeList-head">
        <ul class="k-videoTypeList">
          <li v-for="(item, index) in videoTypeList"
              :key="index"
              :class="index === currentVideoIndex ? 'k-doctypelist-active' : ''"
              @click="changeVideoIndex(index)">
            {{ item.videoTypeName }}
          </li>
        </ul>
        <!-- 技术视频列表跳转 -->
        <router-link class="k-doctypelist-more"
                     to="/knowledgeVideoList">
          <span>更多</span>
          <!-- <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC"> -->
          <div class="morePicture"></div>
        </router-link>
      </div>
      <!-- 技术视频展示 -->
      <div class="k-video-list">
        <div class="k-video-perfect">
          <!-- <img class="k-doctype k-hotdoc" src="data:image/png;base64,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"> -->
          <!-- <img :src="videoTypeList[currentVideoIndex].perfectVideos[0].path + '?x-oss-process=video/snapshot,t_0000,f_jpg,w_316,h_400,m_fast'"> -->
          <img
            class="k-video-adv"
            :src="BASE_URL + 'img/appearanceAdvertisement.jpg'"
            alt="中核仪表广告"
          />
        </div>
        <ul class="k-video-right"
            v-if="videoTypeList">
          <li style="
              width: 825px;
              height: 490px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              background: #ffffff;
            "
              v-if="
              videoTypeList &&
              videoTypeList[activeVideoIndex] &&
              videoTypeList[activeVideoIndex].allothers &&
              videoTypeList[activeVideoIndex].allothers.length === 0 &&
              videoTypeList[activeVideoIndex].hotVideos === null &&
              videoTypeList[activeVideoIndex].newVideos === null &&
              videoTypeList[activeVideoIndex].firstLevelVideos.length === 0
            "
          >
            <img
              style="display: block; width: 300px; margin-top: -50px"
              :src="BASE_URL + 'img/kong.png'"
              alt="暂无数据"
            />
            <h3 style="font-size: 28px; margin-top: 20px">
              该分类下暂无视频，请选择其他分类
            </h3>
          </li>
          <li v-for="(item, index) in videoTypeList[currentVideoIndex].hotVideos"
              :key="index"
              @click="jumpVideoDetail(item)">
            <div style="
                width: 255px;
                height: 30px;
                position: absolute;
                top: 130px;
                left: 0;
                background: rgba(0, 0, 0, 0.4);
              ">
              <p style="
                  text-align: right;
                  padding-right: 10px;
                  line-height: 30px;
                  color: #ffffff;
                ">
                {{ item.videoViewCount }} 次浏览
              </p>
            </div>
            <img alt="热"
                 class="k-doctype k-hotdoc"
                 src="data:image/png;base64,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" />
            <img alt="播放"
                 class="k-video-play"
                 src="data:image/png;base64,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" />
            <img style="width: 255px; height: 160px"
                 :src="
                item.path +
                '?x-oss-process=video/snapshot,t_1000,f_jpg,w_255,h_160,m_fast'
              " />
            <h3 class="overell">{{ item.videoTitle }}</h3>
            <div class="k-video-text">
              <p>{{ item.createTime }}</p>
              <div class="k-video-collect"
                   @click.stop="changeVideoLikeState(index, item)">
                <img style="margin-top: 7px"
                     class="k-docview-likeicon"
                     :src="item.collectionDataId ? likeUrl : notLikeUrl"
                     alt="" />
                <div style="margin-right: 0"
                     class="k-docview-collect">
                  {{ item.collectionDataId ? "已收藏" : "收藏" }}
                </div>
              </div>
            </div>
          </li>
          <li v-for="(item, index) in videoTypeList[currentVideoIndex].newVideos"
              :key="index + 3"
              @click="jumpVideoDetail(item)">
            <div style="
                width: 255px;
                height: 30px;
                position: absolute;
                top: 130px;
                left: 0;
                background: rgba(0, 0, 0, 0.4);
              ">
              <p style="
                  text-align: right;
                  padding-right: 10px;
                  line-height: 30px;
                  color: #ffffff;
                ">
                {{ item.videoViewCount }} 次浏览
              </p>
            </div>
            <img class="k-doctype k-hotdoc"
                 src="data:image/png;base64,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" />
            <img class="k-video-play"
                 src="data:image/png;base64,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" />
            <img style="width: 255px; height: 160px"
                 :src="
                item.path +
                '?x-oss-process=video/snapshot,t_1000,f_jpg,w_255,h_160,m_fast'
              " />
            <h3 class="overell">{{ item.videoTitle }}</h3>
            <div class="k-video-text">
              <p>{{ item.createTime }}</p>
              <div class="k-video-collect"
                   @click.stop="changeVideoLikeState(index, item)">
                <img style="margin-top: 7px"
                     class="k-docview-likeicon"
                     :src="item.collectionDataId ? likeUrl : notLikeUrl"
                     alt=""
                     @click.stop="
                    changeLikeState4(index, item.collectionDataId, item)
                  " />
                <div style="margin-right: 0"
                     class="k-docview-collect">
                  {{ item.collectionDataId ? "已收藏" : "收藏" }}
                </div>
              </div>
            </div>
          </li>
          <li v-for="(item, index) in videoTypeList[currentVideoIndex].allothers"
              :key="index + 9"
              @click="jumpVideoDetail(item)">
            <div style="
                width: 255px;
                height: 30px;
                position: absolute;
                top: 130px;
                left: 0;
                background: rgba(0, 0, 0, 0.4);
              ">
              <p style="
                  text-align: right;
                  padding-right: 10px;
                  line-height: 30px;
                  color: #ffffff;
                ">
                {{ item.videoViewCount }} 次浏览
              </p>
            </div>
            <img class="k-video-play"
                 alt="播放"
                 src="data:image/png;base64,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" />
            <img :alt="item.videoTitle"
                 style="width: 255px; height: 160px"
                 :src="
                item.path +
                '?x-oss-process=video/snapshot,t_1000,f_jpg,w_255,h_160,m_fast'
              " />
            <h3 class="overell">{{ item.videoTitle }}</h3>
            <div class="k-video-text">
              <p>{{ item.createTime }}</p>
              <div class="k-video-collect"
                   @click.stop="changeVideoLikeState(index, item)">
                <img style="margin-top: 7px"
                     class="k-docview-likeicon"
                     :src="item.collectionDataId ? likeUrl : notLikeUrl"
                     :alt="item.videoTitle"
                     @click.stop="
                    changeLikeState4(index, item.collectionDataId, item)
                  " />
                <div style="margin-right: 0"
                     class="k-docview-collect">
                  {{ item.collectionDataId ? "已收藏" : "收藏" }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 专家问答 -->
    <div class="k-tecdocument">
      <h2>专家问答</h2>
      <!-- 专家问答一级分类选择区域 -->
      <div class="k-doctypelisthead">
        <ul class="k-doctypelist">
          <li v-for="(item, index) in exportTypeList"
              :key="index"
              :class="index === currentExportIndex ? 'k-doctypelist-active' : ''"
              @click="changeExportIndex(index)">
            {{ item.fieldName }}
          </li>
        </ul>
        <!-- 专家问答列表跳转 -->
        <div class="k-doctypelist-more">
          <span>
            <router-link to="/expertIndex"
                         class="moreLink">更多</router-link>
          </span>
          <!-- <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC"> -->
          <div class="morePicture"></div>
        </div>
      </div>
      <!-- 专家问答主体 -->
      <el-row class="bacfff"
              :gutter="10"
              v-if="
          currentExportIndex !== -1 &&
          exportTypeList[currentExportIndex] &&
          exportTypeList[currentExportIndex].expertFieldRepliyVoList
        ">
        <el-col :span="12"
                class="margin10"
                v-for="(item, index) in exportTypeList[
            currentExportIndex
          ].expertFieldRepliyVoList.slice(0, 4)"
                :key="index">
          <el-col class="bacf8">
            <el-col :span="6">
              <!--  style="text-align:center;" -->
              <div></div>
              <div class="tpic" @click.stop="routerHandleExportDetail(item)">
                <img
                  :alt="item.name"
                  :src="item.userAvatarUrl || defaultImg"
                  width="70px"
                  height="70px"
                  style="border-radius: 30px; cursor: pointer"
                />
              </div>
              <div class="ask"
                   @click="routerHandleAskExport(item.id, item.name)">
                我要提问
              </div>
            </el-col>
            <el-col :span="18"
                    class="askbox">
              <h4>{{ item.name }}&nbsp;专家</h4>
              <div v-if="item.fileVideoTypeAttributeEntityList"
                   class="overell">
                <!-- <h4>名称</h4> -->
                <span v-for="(
                    itemLabel, indexLabel
                  ) in item.fileVideoTypeAttributeEntityList"
                      :key="indexLabel">
                  {{ itemLabel.typeAttributeValue }}
                </span>
              </div>
              <div :title="item.expertIntroduction"
                   class="askbox-introduction">
                {{ item.expertIntroduction }}
              </div>
            </el-col>
          </el-col>
        </el-col>
        <el-col>
          <div @click="routerHandleAskExport()">
            <el-col :span="4"
                    :offset="10"
                    class="askbut">我要提问</el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 热门话题 -->
    <div class="k-tecdocument">
      <h2>热门话题</h2>
      <div class="hotTopic"
           v-if="
          currentExportIndex !== -1 &&
          exportTypeList[currentExportIndex] &&
          exportTypeList[currentExportIndex].expertUserArticleVos
        ">
        <div v-for="(item, index) in exportTypeList[currentExportIndex]
            .expertUserArticleVos"
             :key="index"
             @click="postsDetailHandle(item)"
             style="
            cursor: pointer;
            padding: 20px 0;
            border-bottom: 1px solid #eee;
          ">
          <div class="hotTopic-title">
            <h4 class="overell">{{ item.articleTitle }}</h4>
          </div>
          <div>
            <el-row>
              <el-col :span="4">
                <!--  style="padding-top:20px;" -->
                <div class="hotTopic-tpic">
                  <img
                    :alt="item.expertName"
                    :src="item.userAvatarUrl || defaultImg"
                    width="70px"
                    height="70px"
                    style="border-radius: 30px"
                  />
                </div>
                <div>{{ item.expertName }}&nbsp;专家</div>
              </el-col>
              <!-- <el-col :span="1">答：</el-col> -->
              <el-col :span="19">
                <div class="hotTopic-content">
                  <div class="hotTopic-content-icon">&nbsp;</div>
                  <div class="hotTopic-content-main">
                    <div class="hotTopic-content-replay">
                      {{ item.articleContent }}
                    </div>
                    <!-- replyPostContent专家回复 -->
                    <div class="hotTopic-content-endDate">
                      {{
                        item.articleViewCount
                      }}&nbsp;次浏览&nbsp;|&nbsp;发布日期：{{ item.createTime }}
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import { openOther } from '@/utils/index'
// 引入埋单方法
import { track } from '@/utils/knowledgeEventTracking'
// 引入专家相关组件
import {
  expertDetail,
  expertPutQuestionsTo,
  knowledgeStayTime
} from '@/utils/eventTracking'
export default {
  data () {
    return {
      defaultImg: require('@/assets/img/defaultPeopleImg.png'),
      BASE_URL: process.env.BASE_URL,
      startTime: null, // 记录进入页面时间
      activeVideoIndex: 1, // 当前选中的视频类目index(和currentVideoIndex一起存储当前选中的视频类目index)
      fiveSDataList: [], // 知识社区首页轮播图存储对象
      searchtext: '', // 上部知识社区搜索框 v-model
      currentDocType: 0, // 当前选中的文档类目index
      // 收藏后红心icon的base64码
      likeUrl:
        'data:image/png;base64,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',
      // 未收藏时蓝心icon的base64码
      notLikeUrl:
        'data:image/png;base64,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',
      tecDocTypeList: null, // 技术文档分类存储
      tecDocList: null, // 技术文档详情展示存储
      // 上传相关
      uploadFileTitle: '',
      uploadFileScore: 0,
      uploadFileDescribe: '',
      activeUploadFileTypeTwoId: null,
      uploadFileTypeChooseOne: null,
      uploadFileTypeChooseTwo: null,
      uploadData: null,
      activeUploadFileTypeOneIndex: null,
      activeUploadFileTypeTwoIndex: null,
      activeUploadFileTypeThreeIndex: null,
      activeUploadFileTypeThreeId: null,
      uploadFileTypeChooseThree: null,
      isUploadShow: false,
      uploadFile: null,
      headerMsg: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      uploadURL: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/fileConvert',
      exportTypeList: [], // 专家问答列表
      currentExportIndex: -1,
      // 视频相关数据
      currentVideoIndex: 0,
      videoTypeList: null,
      videoList: null,
      nowTimeId: null,
      fileList: []
      // 静态轮播地址
      // communityBanner: [
      //   '/static/img/知识社区-广告位/知识社区诚邀.jpg',
      //   '/static/img/知识社区-广告位/APC软件.jpg',
      //   '/static/img/知识社区-广告位/ABB.jpg',
      //   '/static/img/知识社区-广告位/罗克韦尔.jpg'
      // ]
    }
  },
  methods: {
    // 首页轮播跳转
    getSwiperDetail (id) {
      let temp = this.fiveSDataList.filter((item) => {
        return item.id === id
      })
      if (temp.length) {
        if (temp[0].jump === '1' || temp[0].jump === '3') {
          openOther(decodeURIComponent(temp[0].httpAddress), true)
        } else if (
          temp[0].jump === '2' &&
          temp[0].contect &&
          temp[0].contect.length
        ) {
          this.$router.push({ name: '5sDetail', query: { id: id } })
        }
      }
      // let target = (e && e.target) || (window.event && window.event.srcElement)
    },
    // 首页顶部搜索栏进行知识社区搜索
    jumpSearchPage () {
      // if (this.searchtext === '') {
      //   this.$message.warning('请输入搜索内容再进行搜索')
      // } else {
      this.$router.push({
        path: '/knowledgeSearchPage',
        query: {
          searchType: 'FILE',
          searchContent: this.searchtext
        }
      })
      // }
    },
    // 跳转到专家问答
    jumpExpertAsk () {
      this.$router.push('/chooseExpert')
    },
    // 取消上传
    cancelUpload () {
      this.isUploadShow = false
      if (this.fileList.length) {
        for (let index = 0; index < this.fileList.length; index++) {
          this.removeFile(this.fileList[index])
        }
      }
    },
    // 上传文档选择一级类目动作
    handleUploadFileTypeOneChoose (index, item) {
      if (item.children === null) {
        this.$message.success('此分类仍在建设中，请选择其他分类')
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
      } else {
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.activeUploadFileTypeOneIndex = index
        this.uploadFileTypeChooseTwo = item.children
      }
    },
    // 上传文档选择二级类目动作
    handleUploadFileTypeTwoChoose (index, item) {
      if (item.children === null) {
        this.$message.error('此分类仍在建设中，请选择其他分类')
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = null
      } else {
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = index
        this.activeUploadFileTypeTwoId = item.id
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = item.children
      }
    },
    // 上传文档选择三级类目动作
    handleUploadFileTypeThreeChoose (index, item) {
      this.activeUploadFileTypeThreeIndex = index
      this.activeUploadFileTypeThreeId = item.id
    },
    // el-upload 文件选择超出限制的钩子
    handleExceed () {
      this.$message.error('上传文件数量不能超过一个')
    },
    // el-upload 上传成功后钩子 执行向后台保存aliossid 及类目、标题、描述等信息
    handleSuccess (data) {
      // if (data.result.code !== 0) {
      //   this.$refs.upload.uploadFiles.pop()
      //   this.$message.error(data.result.msg || '上传失败')
      //   return false
      // }
      // console.log(data.result.aliOssId)
      this.$http
        .post(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/save`,
          {
            fileTitle: this.uploadFileTitle,
            score: this.uploadFileScore,
            discribe: this.uploadFileDescribe,
            fileTypeId: this.activeUploadFileTypeThreeId,
            ossId: this.fileList[0].ossId,
            downloaded: true
          }
        )
        .then(({ data: item }) => {
          if (item.code === 0) {
            track.clickUploadFile(this.uploadFileTitle)
            this.$message.success('上传成功，请等待审核')
            this.isUploadShow = false
          } else {
          }
        })
        .catch(() => {
          this.$message.error(
            '服务器记录文档失败，请检查与服务器的连接，稍后再试'
          )
        })
    },
    // 打开上传蒙版
    showUpload () {
      if (this.$store.state.user.id) {
        this.$http
          .post(
            `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFileType`, {
              userId: this.$store.state.user.id || null
            }
          )
          .then(({ data }) => {
            if (data.code === 0) {
              this.isUploadShow = true
              this.uploadFileTitle = ''
              this.uploadFileScore = 0
              this.uploadFileDescribe = ''
              this.activeUploadFileTypeOneIndex = null
              this.uploadFileTypeChooseTwo = null
              this.uploadFileTypeChooseThree = null
              this.activeUploadFileTypeTwoIndex = null
              this.activeUploadFileTypeTwoId = null
              this.activeUploadFileTypeThreeIndex = null
              this.activeUploadFileTypeThreeId = null
              this.$refs.upload.clearFiles()
            } else {
              this.$router.push({ name: 'login' })
            }
          })
          .catch(() => { })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    // 确定上传
    submitUpload (item) {
      if (this.uploadFileTitle === '' || this.uploadFileDescribe === '') {
        this.$message.error('必须填写文档标题以及文档描述才能上传文档')
      } else if (this.uploadFileTitle.length > 200) {
        this.$message.error('文档标题不能超过200字')
      } else if (!/^[0-5]{1}$/.test(this.uploadFileScore)) {
        this.$message.error('文档下载积分请输入0-5')
      } else if (this.uploadFileDescribe.length > 1000) {
        this.$message.error('文档描述不能超过1000字')
      } else if (this.activeUploadFileTypeThreeId === null) {
        this.$message.error('必须选择三级分类才能上传文档')
      } else if (this.fileList.length === 0) {
        this.$message.error('必须选择一个文档才能上传文档')
      } else {
        this.handleSuccess()
        // if (this.$refs.upload.uploadFiles[0].size > 104857600) {
        //   this.$message.error('请不要上传大于100mb的文件')
        //   this.$refs.upload.clearFiles()
        // } else {
        //   // console.log(this.$refs.upload.uploadFiles[0])
        //   // this.$refs.upload.submit()
        //   // this.$refs.upload.submit()
        //   // console.log(this.$refs.upload.uploadFiles[0].name)
        //   // let newName = this.$refs.upload.uploadFiles[0].name.slice(0, this.$refs.upload.uploadFiles[0].name.lastIndexOf('.'))
        //   // // console.log(newName)
        //   // let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
        //   // // console.log(regx.test(newName))
        //   // if (regx.test(newName)) {
        //   //   this.$refs.upload.submit()
        //   // } else {
        //   //   this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        //   // }
        // }
      }
    },
    handleRemove () {
      // console.log(file, fileList)
    },
    handlePreview () {
      // console.log(file)
    },
    // 文档下载 通过有token校验的其他接口验证是否登陆，登陆才能下载
    download (item) {
      if (this.$store.state.user.id) {
        this.$http
          .get(
            `${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/isObjectExist/${item.ossId}`
          )
          .then(({ data }) => {
            track.clickDocDownload(item.fileTitle)
            this.downloadFile(item)
          })
          .catch(() => {
            this.$message.warning('该文件不存在')
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    downloadFile (item) {
      this.$confirm(`下载${item.fileTitle}需要 ${item.score}积分?`, '提示', {
        confirmButtonText: '确定下载',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return this.$http.post(
            `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/userFileAddMinsPoint/${item.id}`
          )
        })
        .then(() => {
          let a = document.createElement('a')
          a.href = `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/aliOssDownLoad/${item.id}/${this.$store.state.user.id}`
          a.click()
        })
        .catch((err) => {
          if (err !== 'cancel') {
            this.$message.warning('积分不足')
          }
        })
    },
    // 实现文档收藏的四个方法（文档对象存在4个list中）
    changeLikeState1 (index, likeState, item) {
      if (getAccessToken()) {
        // console.log(likeState)
        if (likeState === null) {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('收藏成功')
                this.refreshDoc()
                track.clickDocCollection(item.fileTitle)
              }
            })
            .catch(() => {
              // this.$router.push({ name: 'login' })
            })
        } else {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('取消收藏成功')
                this.refreshDoc()
              }
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    changeLikeState2 (index, likeState, item) {
      if (getAccessToken()) {
        if (likeState === null) {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('收藏成功')
                this.refreshDoc()
                track.clickDocCollection(item.fileTitle)
              }
            })
            .catch(() => {
              // this.$router.push({ name: 'login' })
            })
        } else {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('取消收藏成功')
                this.refreshDoc()
              }
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    changeLikeState3 (index, likeState, item) {
      if (getAccessToken()) {
        if (likeState === null) {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('收藏成功')
                this.refreshDoc()
                track.clickDocCollection(item.fileTitle)
              }
            })
            .catch(() => {
              // this.$router.push({ name: 'login' })
            })
        } else {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('取消收藏成功')
                this.refreshDoc()
              }
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    changeLikeState4 (index, likeState, item) {
      if (getAccessToken()) {
        if (likeState === null) {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('收藏成功')
                this.refreshDoc()
                track.clickDocCollection(item.fileTitle)
              }
            })
            .catch(() => {
              // this.$router.push({ name: 'login' })
            })
        } else {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`,
              { collectionType: 'FILE', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.$message.success('取消收藏成功')
                this.refreshDoc()
              }
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    // 收藏视频的方法
    changeVideoLikeState (index, item) {
      // console.log(index, item)
      if (getAccessToken()) {
        if (item.collectionDataId === null) {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`,
              { collectionType: 'VIDEO', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.getVideoList()
                this.$message.success('收藏成功')
                track.clickVideoCollection(item.videoTitle)
              }
            })
            .catch(() => {
              // this.$router.push({ name: 'login' })
            })
        } else {
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`,
              { collectionType: 'VIDEO', collectionDataId: item.id }
            )
            .then(({ data }) => {
              if (data.code === 0) {
                this.getVideoList()
                this.$message.success('取消收藏成功')
              }
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    // 跳转文档详情页
    jumpDocDetail (item) {
      track.clickDocDetail(item.fileTitle)
      this.$router.push({
        path: '/trainbookDocDetail',
        query: {
          fileId: item.id
        }
      })
    },
    // 跳转视频详情页
    jumpVideoDetail (item) {
      track.clickVideoDetail(item.videoTitle)
      this.$router.push({
        path: '/knowledgeVideoDetail',
        query: {
          videoId: item.id
        }
      })
    },
    // 刷新文档部分列表信息
    refreshDoc () {
      this.$http
        .post(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/knowledgeCommunityDisplay/${this.nowTimeId}`, {
            userId: this.$store.state.user.id || null
          }
        )
        .then(({ data }) => {
          this.tecDocList = data.data
          let restList = this.tecDocList.allothers.slice(
            0,
            12 -
            this.tecDocList.newVoList.length -
            this.tecDocList.perfect.length -
            this.tecDocList.hot.length
          )
          this.tecDocList.allothers = restList
        })
    },
    // 文档选择类目变化后向后端重新请求当前选中类目下的文档列表
    changeDocTypeIndex (index, data) {
      this.$http
        .post(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/knowledgeCommunityDisplay/${data.id}`, {
            userId: this.$store.state.user.id || null
          }
        )
        .then(({ data }) => {
          this.nowTimeId = data.id
          this.currentDocType = index
          this.tecDocList = data.data
          let restList = this.tecDocList.allothers.slice(
            0,
            12 -
            this.tecDocList.newVoList.length -
            this.tecDocList.perfect.length -
            this.tecDocList.hot.length
          )
          this.tecDocList.allothers = restList
        })
    },
    // 进入知识社区文档列表页
    jumpDocList () {
      this.$router.push({ path: 'trainbookDocList' })
    },
    // 进入知识社区视频列表页
    jumpVideoList () {
      this.$router.push({ name: 'knowledgeVideoList' })
    },
    // 获取首页轮播图
    get5sImages () {
      this.$http
        .get(
          `/front/user/home/homeRotationChart/selectKnowledgeRotationChartList/true`
        )
        .then(({ data }) => {
          this.fiveSDataList = data.data
        })
    },
    // 获取知识社区文档类目
    getFileType () {
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFirstLevelFileType`
        )
        .then(({ data }) => {
          this.tecDocTypeList = data.data
          this.$http
            .post(
              `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/knowledgeCommunityDisplay/${this.tecDocTypeList[0].id}`, {
                userId: this.$store.state.user.id || null
              }
            )
            .then((data2) => {
              this.nowTimeId = this.tecDocTypeList[0].id
              this.tecDocList = data2.data.data
              let restList = this.tecDocList.allothers.slice(
                0,
                12 -
                this.tecDocList.newVoList.length -
                this.tecDocList.perfect.length -
                this.tecDocList.hot.length
              )
              this.tecDocList.allothers = restList
            })
        })
    },
    // 获取上传所需文档类目树
    getFileUploadType () {
      // this.$http.get(`${window.SITE_CONFIG['apiURL']}/technicaldocumentation/technicalfiletype/searchFileType`)
      // .then(data => {
      //   console.log(data.result.data[0].children)
      //   this.typeListOne = data.result.data
      //   this.uploadFileTypeChooseOne = data.result.data
      //   this.typeListTwo = data.result.data[0].children
      //   this.uploadFileTypeChooseTwo = data.result.data[0].children
      //   this.activeCategoryOne = data.result.data[0].fileTypeName
      //   if (data.result.data[0].children === null || data.result.data[0].children.length === 0) {
      //     this.activeCategoryTwo = null
      //     this.activeCategoryId = null
      //     this.fileTypeId = null
      //   } else {
      //     this.activeCategoryTwo = data.result.data[0].children[0].fileTypeName
      //     this.activeCategoryId = data.result.data[0].children[0].id
      //     this.fileTypeId = data.result.data[0].children[0].id
      //   }
      //   this.activeCategoryOneIndex = 0
      //   this.activeCategoryTwoIndex = 0
      // })
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/variableFileLevel`
        )
        .then(({ data }) => {
          if (data.code === 0) {
            this.typeListOne = data.data
            this.uploadFileTypeChooseOne = data.data
          } else {
          }
        })
        .catch(() => {
        })
    },
    // 获取视频分类及其下属视频
    getVideoList () {
      this.$http
        .post(
          `${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideotype/knowledgeCommunityTypeAndVideo`, {
            userId: this.$store.state.user.id || null
          }
        )
        .then(({ data }) => {
          if (data.code === 0) {
            // console.log(data.result.data)
            this.videoTypeList = data.data
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].hotVideos) {
                if (data.data[i].newVideos) {
                  let newOthers = data.data[i].allothers.slice(
                    0,
                    6 -
                      data.data[i].hotVideos.length -
                      data.data[i].newVideos.length
                  )
                  data.data[i].allothers = newOthers
                } else {
                  let newOthers = data.data[i].allothers.slice(
                    0,
                    6 - data.data[i].hotVideos.length
                  )
                  data.data[i].allothers = newOthers
                }
              } else {
                if (data.data[i].newVideos) {
                  let newOthers = data.data[i].allothers.slice(
                    0,
                    6 - data.data[i].newVideos.length
                  )
                  data.data[i].allothers = newOthers
                } else {
                  let newOthers = data.data[i].allothers.slice(0, 6)
                  data.data[i].allothers = newOthers
                }
              }
            }
          } else {
          }
        })
        .catch(() => {
        })
    },
    // 改变视频激活分类
    changeVideoIndex (index) {
      this.activeVideoIndex = index
      this.currentVideoIndex = index
    },
    // 获取一级专家类别及其下对应的专家
    getExportMenuList () {
      this.currentExportIndex = -1
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldtype/selectHeadAndTails`
        )
        .then(({ data }) => {
          let exportTypeList = data.data || []
          // let all = []
          // let allhotToppic = []
          // exportTypeList.forEach(element => {
          //   if (element.expertFieldRepliyVoList && element.expertFieldRepliyVoList.length) {
          //     all.push(...element.expertFieldRepliyVoList)
          //   }
          //   if (element.expertUserArticleVos && element.expertUserArticleVos.length) {
          //     allhotToppic.push(...element.expertUserArticleVos)
          //   }
          // })
          // if (all.length) {
          //   exportTypeList.unshift({
          //     fieldName: '全部',
          //     expertFieldRepliyVoList: all,
          //     expertUserArticleVos: allhotToppic
          //   })
          //   this.currentExportIndex = 0
          // }
          if (exportTypeList.length) {
            this.currentExportIndex = 0
          } else {
            this.currentExportIndex = -1
          }
          this.exportTypeList = exportTypeList.splice(0, 7)
        })
    },
    // 切换专家当前分类
    changeExportIndex (index) {
      let temp = this.exportTypeList[index]
      if (
        !temp.expertFieldRepliyVoList ||
        !temp.expertFieldRepliyVoList.length
      ) {
        this.$message.warning('暂时没有内容,请浏览其他内容')
      } else {
        this.currentExportIndex = index
      }
    },
    // 3向专家提问
    routerHandleAskExport (id, name) {
      if (id) {
        expertPutQuestionsTo(name)
        this.$router.push({
          name: 'askToExpert',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({ name: 'chooseExpert' })
      }
    },
    // 跳转到专家详细页面
    routerHandleExportDetail (item) {
      expertDetail(item.name)
      this.$router.push({
        name: 'exportDetail',
        query: {
          id: item.id,
          uId: item.userId
        }
      })
    },
    postsDetailHandle (item) {
      this.$router.push({
        name: 'postsDetail',
        query: {
          id: item.id
        }
      })
    },
    // 上传失败
    errorFile () {
      this.subLoading = false
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.code === 0) {
        this.fileList.push({
          uid: file.uid,
          ossId: response.data.aliOssId,
          ossName: file.name,
          name: file.name
          // uploadId: checkpoint.uploadId
        })
        this.subLoading = false
      } else {
        // console.log(this.$refs.upLoadFile.onRemove(file, fileList), file)
        // file.onError(file)
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(response.msg || '上传失败')
        this.subLoading = false
      }
    },
    // 上传
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
        let type = file.name.split('.')[1]
        let fileAcceptList = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx']
        if (!fileAcceptList.includes(type)) {
          this.$message.error('请上传正确的文件类型')
          return false
        }
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    // 删除文件
    removeFile (file) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId) {
        let index = this.fileList.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, [this.fileList[index].ossId])
            .then(item => {
              this.fileList.splice(index, 1)
            })
            .catch(() => {
            })
        }
      }
    }
  },
  created () {
    this.startTime = new Date()
    this.getExportMenuList()
    this.currentDocType = 0
    this.getFileUploadType()
    this.get5sImages()
    this.getFileType()
    this.getVideoList()
  },
  mounted () {
    // console.log('111')
  },
  destroyed () {
    if (this.startTime) {
      let time = (new Date().getTime() - this.startTime.getTime()) / 1000.0
      knowledgeStayTime(time)
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
/* 知识社区整体版心 */
.knowledge-container {
  width: 1190px;
  /* padding: 0 20px; */
  margin: 0 auto;
}
.upload-cancel {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  font-size: 14px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.upload-cancel:hover {
  opacity: 0.8;
}
.doc-upload {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.doc-upload-area h3 {
  height: 30px;
  font-size: 20px;
  margin: 10px 0;
  color: #333333;
}
.uploadPickUp {
  width: 106px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #595959;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.uploadPickUp .el-icon-upload2 {
  color: #595959;
  font-size: 14px;
}
.doc-upload-area input {
  width: 92%;
  margin: 0 auto;
  line-height: 24px;
  font-size: 18px;
  display: block;
  border: 1px solid #cccccc;
  padding: 4px 10px;
  border-radius: 6px;
}
.doc-upload-area input:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-typechoose ul {
  padding-left: 80px;
}
.doc-upload-kindonechoose ul {
  margin-top: -30px;
}
.doc-upload-kindonechoose ul li {
  list-style: none;
}
.doc-upload-area textarea {
  width: 92%;
  height: 80px;
  line-height: 20px;
  resize: none;
  font-size: 16px;
  margin: 0 auto 20px auto;
  display: block;
  padding: 4px 10px;
  border: 1px solid #cccccc;
  border-radius: 6px;
}
.doc-upload-area textarea:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-area .el-upload__tip {
  word-break: break-all;
}
.doc-upload-fileorvedio {
  display: flex;
  margin-bottom: 20px;
}
.doc-upload-fileorvedio div {
  padding: 2px 10px;
  text-align: center;
  margin: 0 10px;
  border: 1px solid #1d65a8;
  user-select: none;
  cursor: pointer;
}
.uploadFileTypeOneActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindonechoose {
  margin-bottom: 20px;
}
.doc-upload-kindonechoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindonechoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
.uploadFileTypeTwoActive {
  background: #1d65a8;
  color: #ffffff;
}
.uploadFileTypeThreeActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindtwochoose {
  margin-bottom: 20px;
}
.doc-upload-kindtwochoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindtwochoose ul li {
  list-style: none;
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
/* 顶部轮播图 */
.k-banner {
  height: 400px;
  margin-bottom: 30px;
}
.el-carousel__arrow {
  display: none;
}
.el-carousel {
  height: 400px;
}
.el-carousel__container {
  height: 400px;
}
.el-carousel__item {
  height: 400px;
}
.el-carousel__item img {
  cursor: pointer;
  height: 400px;
  width: 1190px;
  display: block;
}

/* 功能（搜索以及上传）区域 */
.k-function {
  display: flex;
  padding: 0 45px;
  margin-bottom: 30px;
}
.k-f-ask {
  user-select: none;
  cursor: pointer;
}
.k-f-ask:hover {
  background: #174773;
}
.k-f-s {
  display: inline-block;
  width: 46px;
  height: 46px;
  margin-left: -46px;
  cursor: pointer;
  z-index: 100;
}
.k-search {
  padding: 0 20px;
  width: 750px;
  height: 46px;
  border: none;
  /* background: url(data:image/png;base64,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) no-repeat 715.5px 16.2px;
  background-size: 13px 13px; */
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
  /* background: url(data:image/png;base64,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) no-repeat 725px 16px;
  background-size: 16px 16px; */
}
.k-search::-webkit-input-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-search:-moz-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-search:-ms-input-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-function button {
  border: none;
  background: #1d65a8;
  width: 150px;
  height: 46px;
  color: #ffffff;
  font-size: 16px;
  line-height: 46px;
  margin-left: 20px;
}

/* 技术文档区域 */
.k-tecdocument h2 {
  font-size: 26px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 10px;
  margin-top: 20px;
}
.k-doctypelisthead {
  display: flex;
  position: relative;
}
.k-doctypelist-more {
  position: absolute;
  right: 0;
  padding-left: 8px;
  padding-right: 5px;
  font-size: 14px;
  color: #262626;
  display: flex;
  line-height: 32px;
  user-select: none;
  cursor: pointer;
}
.k-doctypelist-more:hover span {
  color: #ffffff;
}
.morePicture {
  width: 10px;
  height: 11px;
  display: block;
  margin-top: 10px;
  margin-left: 6px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover {
  background: #1d65a8;
  color: white;
}
.k-doctypelist-more:hover .morePicture {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTNGRUVFQjFDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTNGRUVFQjJDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBM0ZFRUVBRkM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBM0ZFRUVCMEM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Puq9PDkAAABxSURBVHjalJNJDsAwCAPB//8zbaUeXArBcMgmD4FE9oiwO57BTQi8YqN5BDhzKIBtINBagpD2I4Ti7AihubmFcOivhDC84g+C8FcfSAG4B8dGPJUUVVnYiDugFVfAUZyBUcyAJM6OM8Wm7DjJ05cAAwA/gRgnP8oHOgAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover .moreLink {
  color: white !important;
}
.k-doctypelist {
  display: flex;
  flex-wrap: wrap;
  width: 1100px;
  height: 32px;
  overflow: hidden;
  margin-bottom: 19px;
}
.k-doctypelist li {
  list-style: none;
  height: 32px;
  line-height: 32px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  padding: 0 10px;
}
.k-doctypelist li:hover {
  background: #1d65a8;
  color: white;
}
.k-doctypelist-active {
  background: #1d65a8;
  color: #ffffff;
}
.k-doclist {
  display: flex;
  flex-wrap: wrap;
  /* border: 1px solid #cccccc; */
}
.k-doclist li {
  list-style: none;
  width: 396px;
  height: 220px;
  box-sizing: border-box;
  position: relative;
  padding: 20px 27px 33px 31px;
  user-select: none;
  cursor: pointer;
}
.k-doclistv-view {
  border: 1px #f9f9f9 solid;
  /* border-bottom: 1px #eeeeee solid;
  border-top: 1px #fff solid;
  border-right: 1px #fff solid; */
  background: #fff;
}
.k-doclistv-view p{
  margin-top: 0;
}
.k-doclistv-view:hover {
  border: 1px solid #1d65a8;
  padding: 20px 27px 33px 31px;
}
.k-doclistv-view:hover .k-doctype {
  /* margin: -2px 0 0 -2px; */
}
.k-doctype {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0;
}
.k-doclist li h3 {
  font-size: 16px;
  line-height: 45px;
}
.k-doclist li p {
  line-height: 21px;
  font-size: 13px;
  color: #999999;
  margin-bottom: 14px;
  height: 42px;
  overflow: hidden;
}
.k-docauthor {
  display: flex;
  line-height: 30px;
  position: relative;
  margin-bottom: 24px;
}
.k-docauthor-icon {
  width: 29px;
  height: 30px;
  border-radius: 50%;
}
.k-docauthor-name {
  margin-left: 10px;
  font-size: 13px;
  color: #696969;
}
.k-docauthor-date {
  position: absolute;
  right: 8px;
}
.k-docview {
  display: flex;
  position: relative;
}
.k-docview-use {
  display: flex;
  position: absolute;
  right: 8px;
}
.k-docview-likeicon {
  width: 14px;
  height: 13px;
  display: block;
  margin-top: 4px;
}
.k-docview-collect {
  color: #1d65a8;
  margin-right: 32px;
  padding-left: 4px;
}
.k-docview-downloadicon {
  width: 15px;
  height: 15px;
  display: block;
  margin-top: 2px;
}
.k-docview-download {
  color: #1d65a8;
  padding-left: 4px;
}
.k-f-upload {
  user-select: none;
  cursor: pointer;
}
.k-f-upload:hover {
  background: #174773;
}
/* 技术视频 */
.k-video {
  margin-top: 20px;
}
.k-video h2 {
  font-size: 26px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 10px;
}
.k-videoTypeList-head {
  display: flex;
  position: relative;
}
.k-videoTypeList {
  display: flex;
  flex-wrap: wrap;
  width: 1100px;
  height: 32px;
  overflow: hidden;
  margin-bottom: 19px;
}
.k-videoTypeList li {
  list-style: none;
  height: 32px;
  line-height: 32px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  padding: 0 10px;
}
.k-videoTypeList li:hover {
  background: #1d65a8;
  color: white;
}
.k-video-list {
  display: flex;
  margin-bottom: 30px;
}
.k-video-perfect {
  width: 316px;
  height: 522px;
  position: relative;
}
.k-video-right {
  width: 875px;
  display: flex;
  flex-wrap: wrap;
  padding-left: 40px;
  padding-top: 30px;
  padding-right: 9px;
  background: #ffffff;
}
.k-video-right li {
  list-style: none;
  width: 255px;
  margin-right: 20px;
  height: 218px;
  position: relative;
  user-select: none;
  cursor: pointer;
}
.k-video-right li h3 {
  font-size: 16px;
  color: #333333;
  line-height: 36px;
}
.k-video-play {
  width: 38.7px;
  height: 38.7px;
  position: absolute;
  top: 60px;
  left: 108px;
}
.k-video-adv {
  width: 316px;
  height: 522px;
}
.k-video-collect {
  display: flex;
}
.k-video-text {
  display: flex;
  line-height: 26px;
}
.k-video-text p {
  flex: 1;
  font-size: 12px;
  color: #666666;
}
/* 专家问答 */
.tpic {
  border-radius: 50px;
  height: 70px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 10px;
  /* margin: 20px 10px 10px 10px; */
  width: 70px;
  overflow: hidden;
}
.ask {
  width: 80px;
  margin: 0 auto;
  border: 1px #1d65a8 solid;
  text-align: center;
  line-height: 35px;
  color: #1d65a8;
  margin-bottom: 20px;
}
.ask:hover {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.bacf8 {
  background: #f8f8f8;
}
.bacfff {
  background: #ffffff;
  height: auto;
  margin-top: 0px;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.margin10 {
  margin: 10px 0px;
}
.askbox {
  margin-top: 15px;
  text-align: left;
}
.askbox h4 {
  line-height: 30px;
}
.askbox span {
  line-height: 20px;
  margin-bottom: 20px;
  height: 45px;
}
.askbox-introduction {
  height: 54px;
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 100%;
  color: #999;
  word-wrap: break-word;
  word-break: break-all;
}
.askbut {
  background: #1d65a8;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  margin-top: 10px;
  margin-bottom: 20px;
}
.askbut:hover {
  background: #2b7dca;
  cursor: pointer;
}
/* 热门话题 */
.hotTopic {
  background-color: #fff;
  padding: 30px;
  word-wrap: break-word;
  word-break: break-all;
}
.hotTopic-title {
  padding-bottom: 20px;
}
.hotTopic-tpic {
  width: 70px;
  height: 70px;
  border-radius: 35px;
  /* border: #262626 1px solid; */
  overflow: hidden;
}
.hotTopic-content {
  width: 100%;
  position: relative;
}
.hotTopic-content-icon {
  margin-right: 6px;
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  /* background: #1D65A8; */
  color: #fff;
}
.hotTopic-content-main {
  position: absolute;
  top: 0;
  left: 30px;
  display: inline-block;
  width: 100%;
}
.hotTopic-content-replay {
  height: 60px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin-bottom: 10px;
  color: #999;
}
.hotTopic-content-endDate {
  text-align: right;
}
.overell {
  margin: 0;
  /* color: #999; */
}
ul {
  padding-left: 0;
}
p {
  margin: 0;
}
</style>
